import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CustomerService } from 'Service/api/customer-service';
import { redux } from 'Core/redux';

export const STORE_KEY = 'customer';
export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCustomers = createAsyncThunk(
  'customer/fetchCustomers',
  async (filters, { rejectWithValue }) => {
    const response = await CustomerService.getAllCustomers();
    return response.response;
  },
);

export const { actions, reducer } = createSlice({
  name: STORE_KEY,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCustomers.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

redux.injectReducer(STORE_KEY, reducer);
